import { useCallback } from "react";

import { useBrandColorContext } from "@/contexts/BrandColorContext";
import { useT } from "@/i18n";

export const useGetPageTitle = () => {
  const t = useT();
  const { title: platformTitle } = useBrandColorContext();

  const getPageTitle = useCallback(
    (title: string) => {
      return t("general.components.pageTitle", { platformTitle, title });
    },
    [platformTitle, t]
  );

  return getPageTitle;
};
